/**
 * Lab bet-ticker Event cell: truncated CSS + `title` for hover.
 * Empty/missing → em dash, no title (native tooltip only when useful).
 */
export function tickerEventNameDisplay(eventName: string | null | undefined): {
  text: string
  title?: string
} {
  const name = (eventName ?? '').trim()
  if (!name) return { text: '—' }
  return { text: name, title: name }
}
